import React, { Component } from 'react';
import { PropTypes } from 'prop-types';

import { Button, Container } from '../../Components';
import isValid from '../../utils/validFuncs';
import styles from './style';
import * as arrayUtils from '../../utils/array';
import genInput from '../factory';

const showError = (msg) => { console.log(msg); };

export default class SearchPart extends Component {
  constructor() {
    super();
    this.state = { searchStatus: false };
    this.search = this.search.bind(this);
    this.genInput = genInput.bind(this);
  }
  componentDidMount() {
    console.log('push complete');
  }
  getSearchData() {
    const { conditions } = this.props;
    const data = {};
    arrayUtils.forEach(conditions, (condition) => {
      if (condition.items) {
        arrayUtils.forEach(condition.items, (item) => {
          const $$dom = this[`$$${item.key}`];
          const value = $$dom.getValue ? $$dom.getValue() : $$dom.value;
          data[item.key] = item.format ? item.format(value) : value;
        });
      } else {
        const $$dom = this[`$$${condition.key}`];
        const value = $$dom.getValue ? $$dom.getValue() : $$dom.value;
        data[condition.key] = condition.format ? condition.format(value) : value;
      }
    });

    return data;
  }

  // 表单验证
  // 每一项：
  // getValue: 获取输入值
  // valid: string/function/reg
  // errorMsg: 报错文字
  isValid() {
    const { conditions } = this.props;
    let hasShowError = false;
    return arrayUtils.every(conditions, (item) => {
      const { valid, errorMsg } = item;
      const $$dom = this[`$$${item.key}`];
      const value = $$dom.getValue ? $$dom.getValue() : $$dom.value;
      const res = isValid(value, valid);

      if (!hasShowError && !res && errorMsg) {
        showError(errorMsg);
        hasShowError = true;
      }
      return res;
    });
  }
  search() {
    const { beforeSearch, onSearch } = this.props;
    // if (!this.isValid()) {
    //   return;
    // }
    if (beforeSearch) {
      beforeSearch();
    }

    const data = this.getSearchData();
    onSearch(data);
  }
  render() {
    const { conditions, title } = this.props;
    return (
      <div>
        <Container
          style={styles.container}
          title={title}
        >
          {
            conditions.map(condition => (
              <div
                style={styles.line}
                key={condition.key}
              >
                <span
                  style={styles.label}
                >
                  {condition.text}：
                </span>
                {
                  (condition.items || [condition]).map(item =>
                    <span>
                      {
                        this.genInput(item)
                      }
                      <span style={styles.after}>{item.after || ''}</span>
                    </span>
                  )
                }
              </div>
            ))
          }
          <br />
        </Container>
        <div
          style={styles.buttons}
        >
          <Button
            text="查询"
            type={['large', 'primary']}
            style={styles.button}
            onClick={this.search}
            disabled={this.state.searchStatus}
          />
        </div>
      </div>
    );
  }
}

SearchPart.propTypes = {
  title: PropTypes.string,
  conditions: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.string,
    key: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    format: PropTypes.func,
  })),
  beforeSearch: PropTypes.func,
  onSearch: PropTypes.func,
};

SearchPart.defaultProps = {
  title: '查询列表',
  method: 'get',
  conditions: [],
  beforeSearch: () => {},
  onSearch: () => {}
};



// WEBPACK FOOTER //
// ./src/Parts/SearchPart/index.js